import { ModalOptions } from "./types";
import { createWithEqualityFn } from "zustand/traditional";

export interface ModalStore {
  hidden: boolean;
  reset: () => Promise<void>;
  openModal: (
    name: string,
    modalOptions?: ModalOptions,
    contentProps?: unknown,
  ) => void;
  removeModalContent: (name?: string) => void;
  closeModal: (name?: string) => void;
  closeAllModals: () => void;
  updateModalOptions: (name: string, options: ModalOptions) => void;
  anyModalOpen: () => boolean;
}

const useModalStore = createWithEqualityFn<ModalStore>(() => ({
  hidden: false,
  reset: async () => {},
  openModal: (name) => {
    console.warn(
      `::modalStore - openModal (${name}) ignored; legacy modal stack was removed.`,
    );
  },
  removeModalContent: () => {},
  closeModal: () => {},
  closeAllModals: () => {},
  updateModalOptions: () => {},
  anyModalOpen: () => false,
}));

export const modalStoreReset = useModalStore.getState().reset;

export default useModalStore;
